import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { TemplateGuidelines } from "../../../../context/types";
import { THEME_COLORS } from "../../../../context/constants";

interface TemplateGuidelinesDialogProps {
  open: boolean;
  onClose: () => void;
  guidelines: TemplateGuidelines;
}

const TemplateGuidelinesDialog: React.FC<TemplateGuidelinesDialogProps> = ({
  open,
  onClose,
  guidelines,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "8px",
          overflow: "hidden",
          maxWidth: "800px",
        },
      }}
    >
      <DialogTitle sx={{ backgroundColor: THEME_COLORS.yellow, color: "#000" }}>
        {guidelines.title || `How to use ${guidelines.template_id}`}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" gap={4}>
          {/* Text Content */}
          <Box flex={1} minWidth="300px">
            {guidelines.description && (
              <Typography variant="body1" paragraph>
                {guidelines.description}
              </Typography>
            )}
          </Box>

          {/* Video Example - Scaled down */}
          {guidelines.videoExample && (
            <Box width="300px" flexShrink={0}>
              <video
                src={guidelines.videoExample}
                controls
                style={{
                  width: "50%",
                  borderRadius: "4px",
                }}
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: THEME_COLORS.black }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateGuidelinesDialog;
